import React, { Suspense, useEffect } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types';
import ConfirmAction from 'components/confirm-action/ConfirmAction';
import ErrorBoundary from 'components/error-boundary/ErrorBoundary';
import lazyWithRetry from 'helpers/lazyWithRetry';
import { logoutAndClearSession } from '../../services/http-service';
import { trackEvent } from 'helpers';

// Lazy load to keep the heavy form stack out of the initial bundle.
// These modals are mounted in the eager app shell (not behind a route), so a
// chunk-load failure here is wrapped in an ErrorBoundary + retry to avoid
// white-screening the whole app on a stale deploy.
const DetailsRequiredModal = lazyWithRetry(
  () => import('components/details-required-modal'),
  'details-required-modal',
);
const MarketScanConfirmPurchase = lazyWithRetry(
  () => import('components/market-scan-confirm-purchase'),
  'market-scan-confirm-purchase',
);

interface IDispatchProps {}

export const RootModalContainer = ({ layout }: IAppState & IDispatchProps) => {
  useEffect(() => {
    if (layout.isSessionExpired === true) {
      trackEvent('Web-App-Session-Expired-Show');
    }
  }, [layout.isSessionExpired]);

  return (
    <>
      <ConfirmAction
        open={layout.isSessionExpired}
        basic
        header="Session expired"
        onConfirm={logoutAndClearSession}
        hideCancel={true}
        content="You will be logged out, please login again."
        confirmText="Ok"
      />
      <ErrorBoundary>
        <Suspense fallback={null}>
          <DetailsRequiredModal />
          <MarketScanConfirmPurchase />
        </Suspense>
      </ErrorBoundary>
    </>
  );
};

const mapStateToProps = (state: IAppState) => ({
  ...state,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RootModalContainer);
